export default {
    i18n: {
        "Receiver Info": "ข้อมูลผู้รับ",
        "No Permission": "ไม่มีสิทธิ์",
        "Device deleted successfully": "ลบอุปกรณ์สำเร็จแล้ว",
        "Failed to delete device": "ลบอุปกรณ์ไม่สำเร็จ",
        "log id": "รหัสเข้าสู่ระบบ",
        "Create HW SN Config Empty SN.": "สร้าง HW SN Config SN ว่างเปล่า.",
        "The SN": "SN",
        "SN can contain up to 32 characters.": "SN สามารถมีอักขระได้สูงสุด 32 ตัว",
        "Check HW SN Not Found.": "ตรวจสอบ HW SN ไม่พบ",
        "the end user not found": "ไม่พบผู้ใช้ปลายทาง",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "รหัส PIN {0} หลักสามารถใช้งานได้เมื่อสมาร์ทล็อก akubela เชื่อมต่อกับเครือข่ายแล้ว กรุณาทราบว่าอาจใช้เวลาสักครู่หลังการซิงโครไนซ์ก่อนที่รหัส PIN จะมีผล",
        "Stay Alarm": "สัญญาณเตือนโหมดอยู่บ้าน",
        "Family Call": "สายโทรศัพท์ครอบครัว",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "ในระหว่างการอัปเกรด ฟังก์ชันที่เกี่ยวข้องกับล็อกทั้งหมดจะไม่สามารถใช้งานได้ชั่วคราว",
        "None": "ไม่มี",
        "8-digit PIN code starting with \"9\" is invalid!": "รหัส PIN 8 หลักที่ขึ้นต้นด้วย \"9\" ไม่ถูกต้อง!",
        "DetectionLogs": "บันทึกการตรวจจับ",
        "packageIn": "พัสดุเข้า",
        "packageOut": "นำพัสดุออก",
        "cancel": "ยกเลิก",
        "tamperAlarm": "สัญญาณเตือนการงัดแงะ",
        "doorLogs": "บันทึกการเปิดประตู",
        "callHistory": "ประวัติการโทร",
        "activities": "บันทึกการใช้งาน",
        "failedToUnlock": "ปลดล็อกไม่สำเร็จ",
        "visitor": "ผู้เยี่ยมชม",
        "call": "โทร",
        "indoorMonitor": "จอมอนิเตอร์ในร่ม",
        "guardPhone": "โทรศัพท์ผู้ดูแล",
        "manually": "ด้วยตนเอง",
        "automatically": "โดยอัตโนมัติ",
        "nfc": "NFC",
        "bluetooth": "บลูทูธ",
        "auto": "อัตโนมัติ",
        "open": "เปิด",
        "close": "ปิด",
        "deliverySystemVerification": "การตรวจสอบระบบจัดส่ง",
        "amenityReservation": "การจองสิ่งอำนวยความสะดวก",
        "idAccess": "การเข้าถึงบัตรประชาชน",
        "handset": "ที่จับ",
        "exitButton": "ปุ่มเปิดประตู",
        "unlock": "ปลดล็อก",
        "lock": "ปิดประตู",
        "iqPinVerificationFailed": "การตรวจสอบ IQ PIN ล้มเหลว.",
        "accountBlacklisted": "บัญชีถูกขึ้นบัญชีดำ.",
        "outsideAuthorizedTime": "นอกเวลาที่ได้รับอนุญาต",
        "gatewayConnectionUnavailable": "ไม่สามารถเชื่อมต่อกับเกตเวย์ได้",
        "gatewayBusy": "เกตเวย์กำลังยุ่ง",
        "{0}Unlock": "{0} ปลดล็อก",
        "{0}Lock": "{0} ล็อก",
        "capture&Video": "จับภาพ & วิดีโอ",
        "confirmToDeleteIt?": "ยืนยันที่จะลบหรือไม่?",
        "caller": "ผู้โทร",
        "receiver": "ผู้รับ",
        "Happended On": "เกิดขึ้นเมื่อ",
        "callDuration": "ระยะเวลาการโทร",
        "motionDetection": "การตรวจจับการเคลื่อนไหว",
        "packageDetection": "การตรวจจับพัสดุ",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "บัญชีผู้ดูแลระบบหมดอายุการเข้าสู่ระบบแล้ว\nกรุณาติดต่อผู้ให้บริการของคุณ",
        "captureLogs": "บันทึกภาพหน้าจอ",
        "yesterday": "เมื่อวานนี้",
        "Edit Milesight NVR": "แก้ไข Milesight NVR",
        "Add Milesight NVR": "เพิ่ม Milesight NVR",
        "Password": "รหัสผ่าน",
        "Username": "ชื่อผู้ใช้",
        "NVR Address": "ที่อยู่ NVR",
        "NVR Name": "ชื่อ NVR",
        "URL": "ที่อยู่ URL",
        "Added Successfully!": "เพิ่มสำเร็จแล้ว!",
        "Back": "กลับ",
        "Delete Device": "ลบอุปกรณ์",
        "Device List": "รายการอุปกรณ์",
        "Are you sure you want to delete this device?": "คุณแน่ใจหรือว่าต้องการลบอุปกรณ์นี้?",
        "Are you sure you want to cancel?": "คุณแน่ใจหรือว่าต้องการยกเลิก?",
        "Video Storage": "การจัดเก็บวิดีโอ",
        "Function": "ฟังก์ชัน",
        "Unlimited": "ไม่จำกัด",
        "Video Saving": "การบันทึกวิดีโอ",
        "Auto-record video when door unlocks": "บันทึกวิดีโออัตโนมัติเมื่อปลดล็อกประตู",
        "Auto-record video during calls": "บันทึกวิดีโออัตโนมัติระหว่างการโทร",
        "Auto-record video on motion detection, package detection": "บันทึกวิดีโออัตโนมัติเมื่อมีการตรวจจับการเคลื่อนไหว\,การตรวจจับพัสดุ",
        "Manual video recording in monitoring": "การบันทึกวิดีโอแบบแมนนวลในการตรวจสอบ",
        "Saved for {0}days": "บันทึกไว้เป็นเวลา {0} วัน",
        "Saved for 30days/60days/90days": "บันทึกไว้เป็นเวลา 30วัน/60วัน/90วัน",
        "A 7-day free trial is included with your subscription.": "การสมัครสมาชิกของคุณจะรวมการทดลองใช้งานฟรี 7 วัน",
        "To subscribe, please contact your provider for activation.": "หากต้องการสมัครสมาชิก กรุณาติดต่อผู้ให้บริการของคุณเพื่อเปิดใช้งาน",
        "Subscribed Plan": "แผนการสมัครสมาชิก",
        "Device(s) for Video Storage": "อุปกรณ์สำหรับจัดเก็บวิดีโอ",
        "Supported Devices: {0}": "อุปกรณ์ที่รองรับ: {0}",
        "Expiration Time": "เวลาหมดอายุ",
        "For service renewal, please reach out to your provider.": "สำหรับการต่ออายุบริการ กรุณาติดต่อผู้ให้บริการของคุณ",
        "Allow the Property Manager to view recorded videos": "อนุญาตให้ผู้จัดการอสังหาริมทรัพย์ดูวิดีโอที่บันทึกไว้",
        "Lock List": "รายการล็อก",
        "Link Device Relay": "เชื่อมโยงรีเลย์อุปกรณ์",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "เมื่อมีการเชื่อมต่อกลอนกับรีเลย์ กลอนจะถูกปลดล็อกเมื่อรีเลย์ถูกกระตุ้น",
        "Delete": "ลบ",
        "Device Information": "ข้อมูลอุปกรณ์",
        "Please ensure the WiFi network is working properly.": "กรุณาตรวจสอบให้แน่ใจว่าเครือข่าย WiFi ทำงานได้อย่างถูกต้อง",
        "Tips": "คำแนะนำ",
        "Add akubela Smart Locks": "เพิ่มสมาร์ทล็อค akubela",
        "Edit akubela Smart Locks": "แก้ไข akubela Smart Locks",
        "Upgrade": "อัปเกรด",
        "Upgrading...": "กำลังอัปเกรด...",
        "This process will take some time, please be patient.": "กระบวนการนี้จะใช้เวลาสักครู่ กรุณาอดทนรอ",
        "Upgraded Successfully!": "อัปเกรดสำเร็จ!",
        "Upgraded Failed!": "อัปเกรดล้มเหลว!",
        "Please confirm that the WiFi network is functioning properly.": "กรุณายืนยันว่าเครือข่าย WiFi ทำงานได้อย่างถูกต้อง",
        "Please wake up the lock screen.": "กรุณาปลุกหน้าจอล็อก",
        "Editing...": "กำลังแก้ไข...",
        "Edited successfully!": "แก้ไขสำเร็จ!",
        "Edited Failed!": "แก้ไขไม่สำเร็จ!",
        "Check if the WiFi is operating on the 2.4GHz band.": "ตรวจสอบว่า WiFi กำลังทำงานบนย่านความถี่ 2.4GHz หรือไม่",
        "Verify that the WiFi password is correct.": "ตรวจสอบว่า รหัสผ่าน WiFi ถูกต้อง",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "โปรดตรวจสอบให้แน่ใจว่าคุณเชื่อมต่อกับฮอตสปอตของอุปกรณ์ที่ถูกต้องในระหว่างการตั้งค่าฮอตสปอต",
        "Adding...": "กำลังเพิ่ม...",
        "Added Failed!": "เพิ่มไม่สำเร็จ!",
        "Lock Offline": "ล็อกออฟไลน์",
        "Door Release PIN": "รหัส PIN สำหรับเปิดประตู",
        "Doors": "ประตู",
        "Smart Locks": "สมาร์ทล็อก",
        "The PIN must be {0} digits.": "รหัส PIN ต้องมี {0} หลัก",
        "Action": "การดำเนินการ",
        "Response": "ผลการดำเนินการ",
        "Success": "ความสำเร็จ",
        "Failed": "ล้มเหลว",
        "Downloading video...": "กำลังดาวน์โหลดวิดีโอ...",
        "Fail to download.": "ดาวน์โหลดไม่สำเร็จ",
        "Download Completed!": "ดาวน์โหลดเสร็จสิ้น!",
        "All Doors": "ทุกประตู",
        "All Locks": "ล็อคทั้งหมด",
        "Select Locks": "เลือกล็อก",
        "Please at least select a door or a lock.": "กรุณาเลือกอย่างน้อยหนึ่งประตูหรือหนึ่งกุญแจล็อก",
        "Please at least select a door.": "กรุณาเลือกประตูอย่างน้อยหนึ่งบาน",
        "This lock has already been added to your apartment.": "ล็อกนี้ได้ถูกเพิ่มไปยังอพาร์ตเมนต์ของคุณแล้ว",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "ล็อกนี้ได้ถูกเพิ่มไปยังอพาร์ตเมนต์อื่นแล้ว กรุณาติดต่อผู้ให้บริการของคุณเพื่อขอความช่วยเหลือ",
        "LockBody Version": "เวอร์ชัน LockBody",
        "View Progress": "ดูความคืบหน้า",
        "Current Version": "เวอร์ชันปัจจุบัน",
        "Available Version": "เวอร์ชันที่มีให้ใช้งาน",
        "Change Log": "บันทึกการเปลี่ยนแปลง",
        "Fingerprint": "ลายนิ้วมือ",
        "Http": "Http",
        "key": "คีย์",
        "No Answer": "ไม่มีการตอบรับ",
        "Card": "บัตร",
        "Property Managers": "ผู้จัดการอสังหาริมทรัพย์",
        "Group Call": "การโทรแบบกลุ่ม",
        "No": "ไม่",
        "Yes": "ใช่",
        "Change WiFi": "เปลี่ยน WiFi",
        "Battery Level": "ระดับแบตเตอรี่",
        "Two-factor Authentication": "การยืนยันตัวตนแบบสองขั้นตอน",
        "Stay Duration": "ระยะเวลาการเข้าพัก",
        "Volume Settings": "การตั้งค่าระดับเสียง",
        "Offline Code": "รหัสออฟไลน์",
        "Obtain": "รับ",
        "Module Version": "เวอร์ชันโมดูล",
        "Please wake up the lock screen and then upgrade.": "กรุณาปลุกหน้าจอล็อกแล้วจึงอัปเกรด",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "เพื่อให้การอัปเกรดสำเร็จ กรุณาตรวจสอบให้แน่ใจว่าระดับแบตเตอรี่ของล็อกสูงกว่า 40% ก่อนดำเนินการต่อ",
        "Device Name": "ชื่ออุปกรณ์",
        "Link Device": "เชื่อมต่ออุปกรณ์",
        "Automatic Locking Time": "เวลาล็อกอัตโนมัติ",
        "WiFi Keep-Alive": "WiFi คงสถานะ",
        "WiFi Setting": "การตั้งค่า WiFi",
        "Connecting the network...": "กำลังเชื่อมต่อเครือข่าย...",
        "Setting WiFi": "การตั้งค่า WiFi",
        "Set successfully!": "ตั้งค่าสำเร็จ!",
        "Set Failed!": "ตั้งค่าไม่สำเร็จ!",
        "The offline code can be used even if the lock is not connected to WiFi.": "รหัสออฟไลน์สามารถใช้งานได้แม้ว่ากุญแจจะไม่ได้เชื่อมต่อกับ WiFi",
        "Enabling this feature will increase the lock\'s power consumption.": "การเปิดใช้งานฟีเจอร์นี้จะทำให้การใช้พลังงานของล็อกเพิ่มขึ้น",
        "Lock Body Version": "เวอร์ชันตัวล็อก",
        "{0} and indoor monitors/guard phones": "{0}แอปและจอมอนิเตอร์ในบ้าน/โทรศัพท์รักษาความปลอดภัย",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} และจอมอนิเตอร์ในบ้าน/โทรศัพท์รักษาความปลอดภัย โดยใช้โทรศัพท์เป็นสำรอง",
        "Indoor monitors/guard phones with {0} as backup": "จอมอนิเตอร์ในอาคาร/โทรศัพท์ยามที่มี {0} เป็นสำรอง",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "เครื่องรับสัญญาณภายใน/โทรศัพท์ยามที่มี {0} เป็นสำรอง สุดท้ายโทรศัพท์มือถือ",
        "{0} Intercom Feature": "ฟีเจอร์อินเตอร์คอม {0}",
        "{0} Intercom Feature is not activated or has expired.": "ฟีเจอร์{0}อินเตอร์คอมยังไม่ได้เปิดใช้งานหรือหมดอายุแล้ว",
        "Capture on {0}": "จับภาพหน้าจอบน {0}",
        "Add Smart Lock": "เพิ่มสมาร์ทล็อก",
        "Offline Code Unlock": "ปลดล็อกด้วยรหัสออฟไลน์",
        "Each offline code can only be used once.": "แต่ละรหัสออฟไลน์สามารถใช้ได้เพียงครั้งเดียวเท่านั้น",
        "Lock name length must be between 1 and 50": "ความยาวชื่อของล็อกต้องอยู่ระหว่าง 1 ถึง 50",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "จำนวนบุคลากรที่ใช้บริการโทรศัพท์มือถือต้องไม่เกินจำนวนบุคลากรที่ใช้บริการ {0} อินเตอร์คอม",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "จำนวนผู้ดูแลระบบที่ใช้บริการโทรศัพท์มือถือต้องไม่เกินจำนวนผู้ดูแลระบบที่ใช้บริการ {0} อินเตอร์คอม",
        "charge type": "ประเภทการคิดค่าบริการ",
        "Please select at least one item.": "กรุณาเลือกอย่างน้อยหนึ่งรายการ",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "จำนวนบุคลากรที่ใช้บริการโทรศัพท์พื้นฐานต้องไม่เกินจำนวนผู้ที่ใช้ SmartPlus Intercom",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "จำนวนผู้ดูแลระบบที่ใช้บริการโทรศัพท์มือถือต้องไม่เกินจำนวนผู้ดูแลระบบที่มีบริการ SmartPlus อินเตอร์คอม",
        "Operation failed!": "ดำเนินการล้มเหลว!",
        "Floor": "ชั้น",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "ไม่สามารถกำหนดค่าเครื่องอ่านให้ใช้ทั้ง Wiegand และ RS485 พร้อมกันได้",
        "parameter error": "ข้อผิดพลาดของพารามิเตอร์",
        "community name already exist": "ชื่อชุมชนมีอยู่แล้ว",
        "personnel app without intercom feature number": "แอปบุคลากรที่ไม่มีหมายเลขฟีเจอร์อินเตอร์คอม",
        "check feature billing charge plan new error": "ตรวจสอบคุณสมบัติการเรียกเก็บเงินแผนค่าบริการข้อผิดพลาดใหม่",
        "subscription not found": "ไม่พบการสมัครสมาชิก",
        "System setting record not found.": "ไม่พบข้อมูลบันทึกการตั้งค่าระบบ",
        "Smart home not enabled.": "ยังไม่ได้เปิดใช้งานบ้านอัจฉริยะ",
        "the apt call type value is invalid.": "ค่าประเภทการโทร apt ไม่ถูกต้อง.",
        "the ip call or sip call value is invalid.": "ค่า ip call หรือ sip call ไม่ถูกต้อง.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "รหัส pinCode ต้องเป็นตัวเลข 2-8 หลัก แต่ไม่สามารถเป็นตัวเลข 8 หลักที่ขึ้นต้นด้วย 9 หรือเว้นว่าง",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard ต้องเป็น A-F0-9 และมีน้อยกว่า 16 บิต หรือเว้นว่าง",
        "owner cannot be empty.": "owner ไม่สามารถเว้นว่างได้.",
        "creator cannot be empty.": "creator ไม่สามารถเว้นว่างได้",
        "the creator type value is invalid": "ค่าประเภทผู้สร้างไม่ถูกต้อง",
        "the IsCreateByPm value is invalid": "ค่า IsCreateByPm ไม่ถูกต้อง",
        "the pinCode already exist": "รหัสพินนี้มีอยู่แล้ว",
        "the rfCard already exist": "rfCard มีอยู่แล้ว",
        "license plate is invalid.": "ป้ายทะเบียนไม่ถูกต้อง.",
        "owner info is invalid.": "ข้อมูลเจ้าของไม่ถูกต้อง",
        "uhf is invalid.": "uhf ไม่ถูกต้อง",
        "time control is invalid.": "การควบคุมเวลาไม่ถูกต้อง",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "คุณได้ถึงขีดจำกัดของป้ายทะเบียนรถ 5 รายการและไม่สามารถเพิ่มได้",
        "the plate already exist": "ป้ายทะเบียนนี้มีอยู่แล้ว",
        "the uhf already exist": "uhf มีอยู่แล้ว",
        "empty community": "ชุมชนว่างเปล่า",
        "no find license Plate": "ไม่พบป้ายทะเบียน",
        "IDAccess mode must be 0, 1, or 2.": "โหมดการเข้าถึง ID ต้องเป็น 0, 1 หรือ 2.",
        "Run field is required when mode is 1 or 2.": "จำเป็นต้องกรอกช่อง Run เมื่อโหมดเป็น 1 หรือ 2.",
        "Serial field is required when mode is 2.": "จำเป็นต้องกรอกช่อง Serial เมื่อโหมดเป็น 2.",
        "the pin cannot be empty": "รหัส PIN ไม่สามารถเว้นว่างได้",
        "the rfCard cannot be empty": "rfCard ไม่สามารถเว้นว่างได้",
        "the IDAccess already exist": "IDAccess มีอยู่แล้ว",
        "the resident cannot be empty": "ไม่สามารถเว้นว่างข้อมูลผู้อยู่อาศัยได้",
        "the fingerprint cannot be empty": "ลายนิ้วมือไม่สามารถเว้นว่างได้",
        "the face cannot be empty": "ใบหน้าไม่สามารถเว้นว่าง",
        "not found pin": "ไม่พบ pin",
        "not found rfCard": "ไม่พบ rfCard",
        "not found IDAccess": "ไม่พบ IDAccess",
        "not found fingerprint": "ไม่พบลายนิ้วมือ",
        "not found face": "ไม่พบใบหน้า",
        "face pic is invalid.": "รูปใบหน้าไม่ถูกต้อง",
        "community build and room cannot be empty.": "การสร้างชุมชนและห้องไม่สามารถเว้นว่างได้.",
        "device info mac cannot be empty.": "ข้อมูลอุปกรณ์ mac ไม่สามารถเว้นว่างได้.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "ประเภทของ scheduler ต้องเป็น 0,1,2 หรือรูปแบบเวลาไม่ถูกต้อง หรือ dataflag ไม่อยู่ในช่วง 0-127.",
        "MAC address cannot be empty.": "MAC address ไม่สามารถเว้นว่างได้",
        "MAC address 0C1105000000 is not allowed.": "ไม่อนุญาตให้ใช้ MAC address 0C1105000000.",
        "MAC address must be 12 hexadecimal characters.": "MAC address ต้องมีอักขระฐานสิบหก 12 ตัว",
        "Scheduler type value is invalid.": "ค่าประเภทของตัวจัดตารางเวลาไม่ถูกต้อง",
        "parse is fail": "การแยกวิเคราะห์ล้มเหลว",
        "the fingerprint already exist": "ลายนิ้วมือมีอยู่แล้ว",
        "the licensePlate cannot be empty": "the licensePlate ไม่สามารถเว้นว่างได้",
        "the licensePlate already exist": "ป้ายทะเบียนนี้มีอยู่แล้ว",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run ต้องเป็นตัวเลข 10 หลักหรือจบด้วย -K",
        "idaccess serial must be 9 digit number.": "idaccess serial ต้องเป็นตัวเลข 9 หลัก",
        "relay not in 0-15": "รีเลย์ไม่อยู่ใน 0-15",
        "security relay not in 0-3": "รีเลย์ความปลอดภัยไม่อยู่ใน 0-3",
        "file name is wrong": "ชื่อไฟล์ผิด",
        "The PersonalAccount is not active.": "บัญชีส่วนตัวไม่ได้เปิดใช้งาน",
        "access mode specified": "ระบุโหมดการเข้าถึง",
        "create community user accessmode failed.": "สร้างโหมดการเข้าถึงผู้ใช้ชุมชนล้มเหลว",
        "delete community user accessmode failed.": "ลบโหมดการเข้าถึงของผู้ใช้ชุมชนไม่สำเร็จ.",
        "Cannot delete building because it has associated users.": "ไม่สามารถลบอาคารได้เนื่องจากมีผู้ใช้งานที่เกี่ยวข้อง",
        "Cannot delete building because it has associated Salto devices.": "ไม่สามารถลบอาคารได้เนื่องจากมีอุปกรณ์ Salto ที่เกี่ยวข้อง",
        "community building not found": "ไม่พบอาคารชุมชน",
        "Invalid Name Display": "แสดงชื่อไม่ถูกต้อง",
        "mobilePhone": "หมายเลขโทรศัพท์มือถือ",
        "motionTime": "เวลาในการตรวจจับการเคลื่อนไหว",
        "motionType": "ประเภทการตรวจจับการเคลื่อนไหว",
        "postalCode": "รหัสไปรษณีย์",
        "The Community does not exist.": "ชุมชนนี้ไม่มีอยู่",
        "Community name": "ชื่อชุมชน",
        "Update CommunityIsInstallerKit Error.": "อัปเดตข้อผิดพลาด CommunityIsInstallerKit Error.",
        "Dis Not SupportCommunityCalls Error.": "ข้อผิดพลาด Dis Not SupportCommunityCalls Error.",
        "Community Has Special Device, Not Allowed To Delete.": "ชุมชนมีอุปกรณ์พิเศษ ไม่อนุญาตให้ลบ",
        "The project smart home switch must be disabled": "ต้องปิดการใช้งานสวิตช์บ้านอัจฉริยะของโครงการ",
        "There are ITec Locks in project": "มี ITec Locks ในโครงการ",
        "There are Salto Locks in project": "ในโครงการมี Salto Locks",
        "There are Dormakaba Locks in project": "ในโครงการมีล็อก Dormakaba",
        "It is rent manager project": "นี่คือโครงการ rent manager",
        "It is installer account": "นี่คือบัญชีผู้ติดตั้ง",
        "floor format": "รูปแบบชั้น",
        "contact preference type": "ประเภทความชอบในการติดต่อ",
        "Floor list is required when not all floors.": "จำเป็นต้องมีรายการชั้นเมื่อไม่ได้รวมทุกชั้น",
        "Building floors list is required when all buildings.": "จำเป็นต้องมีรายการชั้นของอาคารเมื่อมีอาคารทั้งหมด",
        "Indoor monitor name is required.": "จำเป็นต้องระบุชื่อของจอมอนิเตอร์ในร่ม",
        "The primary account is not activated.": "บัญชีหลักยังไม่ได้เปิดใช้งาน",
        "You can\'t create more family member accounts.": "คุณไม่สามารถสร้างบัญชีสมาชิกในครอบครัวเพิ่มเติมได้",
        "community user not found": "ไม่พบผู้ใช้ชุมชน",
        "community is empty": "ชุมชนว่างเปล่า",
        "the end user not master user": "ผู้ใช้ปลายทางไม่ใช่ผู้ใช้หลัก",
        "the end user not member user": "ผู้ใช้ปลายทางไม่ใช่ผู้ใช้สมาชิก",
        "The email already exists and cannot be repeated": "อีเมลนี้มีอยู่แล้วและไม่สามารถใช้ซ้ำได้",
        "The mobile Number already exists": "หมายเลขโทรศัพท์มือถือมีอยู่แล้ว",
        "The room number format error.": "รูปแบบหมายเลขห้องผิดพลาด",
        "community not found": "ไม่พบชุมชน",
        "resident not found": "ไม่พบผู้อยู่อาศัย",
        "installer not found": "ไม่พบตัวติดตั้ง",
        "Operation Failed!": "ดำเนินการล้มเหลว!",
        "You don\'t have operate permission": "คุณไม่มีสิทธิ์ในการดำเนินการ",
        "You cannot select Relay and Door at the same time": "คุณไม่สามารถเลือกรีเลย์และประตูได้ในเวลาเดียวกัน",
        "user don\'t active": "ผู้ใช้ไม่ได้เปิดใช้งาน",
        "User has expired": "ผู้ใช้หมดอายุ",
        "timestamp must be within 3 minutes of current server time": "timestamp ต้องอยู่ภายใน 3 นาทีของเวลาเซิร์ฟเวอร์ปัจจุบัน",
        "cannot find single rf Card.": "ไม่พบ rf Card เดี่ยว",
        "cannot find community rf Card.": "ไม่พบ community rf Card.",
        "smartLock model": "รุ่น smartLock",
        "the project does not open smart home": "โครงการไม่ได้เปิดสมาร์ทโฮม",
        "php web server error": "ข้อผิดพลาดของเซิร์ฟเวอร์เว็บ php",
        "Ins not found.": "ไม่พบ Ins.",
        "RentManage Unit Not Set.": "ยังไม่ได้ตั้งค่าหน่วย RentManage.",
        "add audit log error": "เพิ่มข้อผิดพลาดบันทึกการตรวจสอบ",
        "check building in error": "ตรวจสอบอาคารผิดพลาด",
        "Special devices cannot be deleted": "ไม่สามารถลบอุปกรณ์พิเศษได้",
        "the email is empty": "อีเมลว่างเปล่า",
        "the email format is incorrect": "รูปแบบอีเมลไม่ถูกต้อง",
        "the mobile number is empty": "หมายเลขโทรศัพท์มือถือว่างเปล่า",
        "the mobile number format is incorrect": "รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
        "Site not found": "ไม่พบไซต์",
        "User not found": "ไม่พบผู้ใช้",
        "invalid time format": "รูปแบบเวลาไม่ถูกต้อง",
        "ground floor type": "รูปแบบชั้นกลาง",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "ข้อผิดพลาดช่วงชั้นเริ่มต้น ค่า valid คือ -10 ถึง -1, G0, G1, G2, 1 ถึง 128.",
        "Building ID must be between 1 and 99.": "รหัสอาคารต้องอยู่ระหว่าง 1 ถึง 99.",
        "Community building name": "ชื่ออาคารชุมชน",
        "Building ID already exists in this community.": "รหัสอาคารนี้มีอยู่แล้วในชุมชนนี้",
        "building ID": "รหัสอาคาร",
        "Community building not found.": "ไม่พบอาคารชุมชน",
        "Cannot delete building because it has associated devices.": "ไม่สามารถลบอาคารได้เนื่องจากมีอุปกรณ์ที่เชื่อมโยงอยู่",
        "project is not valid": "โปรเจกต์ไม่ถูกต้อง",
        "Cannot delete building because it has associated salto devices.": "ไม่สามารถลบอาคารได้เนื่องจากมีอุปกรณ์ salto ที่เชื่อมโยงอยู่",
        "Cannot delete building because it has associated iTec devices.": "ไม่สามารถลบอาคารได้เนื่องจากมีอุปกรณ์ iTec ที่เชื่อมโยงอยู่",
        "Cannot delete building because it has associated dormakaba devices.": "ไม่สามารถลบอาคารได้เนื่องจากมีอุปกรณ์ dormakaba ที่เชื่อมโยงอยู่",
        "member limit num": "จำนวนจำกัดสมาชิก",
        "Indoor Monitor No Set Error.": "ข้อผิดพลาด Indoor Monitor No Set Error.",
        "The room not has indoor": "ห้องไม่มีพื้นที่ในร่ม",
        "check user in building error": "ตรวจสอบผู้ใช้ในอาคารผิดพลาด",
        "User": "ผู้ใช้",
        "Group": "กลุ่ม",
        "The name specified is already in use.": "ชื่อที่ระบุถูกใช้งานแล้ว",
        "Company": "บริษัท",
        "ID": "ID",
        "Email": "อีเมล",
        "RF Card": "บัตร RF",
        "License Plate": "ป้ายทะเบียน",
        "Name": "ชื่อ",
        "Face": "ใบหน้า",
        "Accessible Floors": "ชั้นที่เข้าถึงได้",
        "Call Type": "ประเภทการโทร",
        "UHF Card": "บัตรยูเอชเอฟ",
        "minutes": "นาที",
        "Controlled Relay": "รีเลย์ควบคุม",
        "This timeblock overlaps with an existing one. Please adjust it.": "ช่วงเวลานี้ทับซ้อนกับช่วงเวลาที่มีอยู่แล้ว กรุณาปรับเปลี่ยน",
        "The end time cannot be earlier than the start time.": "เวลาสิ้นสุดต้องไม่ก่อนเวลาเริ่มต้น",
        "Address": "ที่อยู่",
        "Time": "เวลา",
        "This door status changed. Please try again.": "สถานะของประตูนี้เปลี่ยนไปแล้ว กรุณาลองใหม่อีกครั้ง",
        "the lock can\'t bind this community": "ล็อคไม่สามารถผูกกับชุมชนนี้ได้",
        "The custom quantity limit has been exceeded!": "จำกัดจำนวนที่กำหนดเองถูกเกินแล้ว!",
        "This time span overlaps with an existing one. Please adjust it.": "ช่วงเวลานี้ทับซ้อนกับช่วงเวลาที่มีอยู่แล้ว กรุณาปรับเปลี่ยน",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "ช่วงเวลาการทำงานครั้งเดียวนี้ซ้อนทับกับช่วงเวลาที่มีผลของการทำงานครั้งเดียวที่มีอยู่ กรุณาปรับเปลี่ยน",
        "UID": "UID",
        "Operation Failed. Please try again.": "ดำเนินการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        "The image is not a front view.": "ภาพนี้ไม่ใช่มุมมองด้านหน้า",
        "A mask was detected.": "ตรวจพบหน้ากาก",
        "The image resolution is too low.": "ความละเอียดของภาพต่ำเกินไป",
        "No face was detected.": "ไม่พบใบหน้า",
        "The file size is too large.": "ขนาดไฟล์ใหญ่เกินไป",
        "The face in the image is too large.": "ใบหน้าในภาพมีขนาดใหญ่เกินไป.",
        "The face in the image is too small.": "ใบหน้าที่อยู่ในภาพมีขนาดเล็กเกินไป",
        "Multiple faces detected.": "ตรวจพบใบหน้าหลายใบ",
        "The face is not clear enough.": "ใบหน้าไม่ชัดเจนเพียงพอ",
        "File format error.": "ข้อผิดพลาดของรูปแบบไฟล์",
        "Face detection failed.": "การตรวจจับใบหน้าล้มเหลว.",
        "User name too long.": "ชื่อผู้ใช้ยาวเกินไป ชื่อผู้ใช้สามารถมีได้สูงสุด 63 อักขระ",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "ลบไม่สำเร็จ! ผู้จัดการทรัพย์สินถูกผูกกับลูกค้า RentManager คุณควรลบออกก่อน",
        "Building": "อาคาร",
        "APT": "ห้อง",
        "Please enter a value between 1 and 9999": "กรุณาใส่ค่าในช่วงระหว่าง 1 ถึง 9999",
        "PIN": "รหัส PIN",
        "Please select which input your door sensor is connected to.": "กรุณาเลือกว่าตัวเซ็นเซอร์ประตูของคุณเชื่อมต่อกับอินพุตใด",
        "Add temp key failed, please try it again": "เพิ่มคีย์ชั่วคราวไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        "Dis Not Support Dynamic QRCode Error.": "ข้อผิดพลาด Dis Not Support Dynamic QRCode Error. ตัวแทนไม่รองรับคิวอาร์โค้ดแบบไดนามิก",
        "QR code not exist": "QR code ไม่พบ",
        "The temp key has expired.": "คีย์ชั่วคราวหมดอายุแล้ว",
        "The device is not in the office": "อุปกรณ์ไม่ได้อยู่ในสำนักงาน",
        "The device is already assigned.": "อุปกรณ์นี้ถูกจัดสรรแล้ว",
        "The device cannot be assigned to any user.": "ไม่สามารถกำหนดอุปกรณ์นี้ให้กับผู้ใช้คนใดได้",
        "You cannot select an option with fewer users than the current project members.": "คุณไม่สามารถเลือกตัวเลือกที่มีจำนวนผู้ใช้น้อยกว่าจำนวนสมาชิกโครงการปัจจุบันได้",
        "Date Time": "เวลา",
        "timezone": "เขตเวลา",
        "Attendance Point Name": "ชื่อจุดลงเวลาการเข้าออกงาน",
        "Please try again 24 hours later.": "กรุณาลองใหม่อีกครั้งหลังจาก 24 ชั่วโมง",
        "Owner": "เจ้าของ",
        "Timeout": "หมดเวลา",
        "Please select a device.": "กรุณาเลือกอุปกรณ์",
        "Password is too weak.": "รหัสผ่านอ่อนเกินไป",
        "Company is required.": "จำเป็นต้องระบุชื่อบริษัท",
        "Your account is not activated, please contact your service provider.": "บัญชีของคุณยังไม่ได้รับการเปิดใช้งาน กรุณาติดต่อผู้ให้บริการของคุณ",
        "Language": "ภาษา",
        "Please set at least one access type.": "กรุณาตั้งค่าประเภทการเข้าใช้งานอย่างน้อยหนึ่งประเภท",
        "Please contact your service provider to activate this advanced feature.": "กรุณาติดต่อผู้ให้บริการของคุณเพื่อเปิดใช้งานฟีเจอร์ขั้นสูงนี้",
        "Please enable PM App first.": "กรุณาเปิดใช้งานแอป PM ก่อน",
        "Assign": "กำหนด",
        "Verification Code": "รหัสยืนยัน",
        "This MAC address is redirected on RPS.": "ที่อยู่ MAC นี้ถูกเปลี่ยนเส้นทางบน RPS.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "กรุณาตรวจสอบว่ามีคำสั่งซื้อที่ยังไม่ได้ชำระเงินหรือไม่ หากไม่มี กรุณาติดต่อผู้ให้บริการของคุณ",
        "date": "วันที่",
        "Password Incorrect.": "รหัสผ่านไม่ถูกต้อง.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID สามารถประกอบด้วยตัวเลขและตัวอักษรเท่านั้น สูงสุดไม่เกิน 32 ตัวอักษร",
        "The PIN is not available.": "รหัส PIN ไม่สามารถใช้ได้",
        "day": "วัน",
        "MAC": "MAC",
        "Code": "รหัส",
        "Model": "รุ่น",
        "Invalid {0}.": "{0} ไม่ถูกต้อง",
        "{0} already exists.": "{0} มีอยู่แล้ว.",
        "Failed to get data.": "ไม่สามารถรับข้อมูลได้",
        "You do not have the necessary permissions to perform this operation.": "คุณไม่มีสิทธิ์ที่จำเป็นในการดำเนินการนี้",
        "You can only import one template at a time in the current site.": "คุณสามารถนำเข้าเทมเพลตได้ครั้งละหนึ่งเท่านั้นในไซต์ปัจจุบัน",
        "Delivery name": "ชื่อสิทธิ์การอนุมัติสำหรับพนักงานจัดส่ง",
        "MAC address not in the MAC library.": "ที่อยู่ MAC ไม่อยู่ในคลัง MAC",
        "Please delete devices under this building.": "กรุณาลบอุปกรณ์ภายใต้\nอาคารนี้",
        "The start time cannot be later than the end time.": "เวลาเริ่มต้นต้องไม่ช้ากว่าเวลาสิ้นสุด",
        "emergency action type": "ประเภทการดำเนินการฉุกเฉิน",
        "Only 1000 data items can be imported at a time.": "สามารถนำเข้าข้อมูลได้ครั้งละไม่เกิน 1000 รายการ",
        "The password is too short.": "รหัสผ่านสั้นเกินไป",
        "The data has been updated. Please refresh the page and try again.": "ข้อมูลได้รับการอัปเดตแล้ว กรุณารีเฟรชหน้าและลองใหม่อีกครั้ง",
        "AutoP length must be less 2048 bytes.": "ความยาว AutoP ต้องน้อยกว่า 2048 ไบต์.",
        "File Check Failed": "ตรวจสอบไฟล์ล้มเหลว",
        "Param": "พารามิเตอร์",
        "This lock has already been added to another apartment.": "ล็อกนี้ได้ถูกเพิ่มไปยังอพาร์ตเมนต์อื่นแล้ว",
        "This lock has already been added to the apartment.": "ล็อกนี้ได้ถูกเพิ่มเข้าไปในอพาร์ตเมนต์แล้ว",
        "Pin Code": "รหัสพิน",
        "Too many failed attempts, please try again in a few minutes.": "มีความพยายามล้มเหลวมากเกินไป กรุณาลองใหม่อีกครั้งในอีกไม่กี่นาที",
        "Login Account": "เข้าสู่ระบบบัญชี",
        "Same account cannot login in different ins.": "บัญชีเดียวกันไม่สามารถเข้าสู่ระบบในผู้ติดตั้งที่แตกต่างกันได้",
        "Lock Name": "ชื่อของล็อก",
        "The selected duration cannot be more than one year.": "ระยะเวลาที่เลือกไม่สามารถเกินหนึ่งปีได้",
        "The end time of the break time cannot be later than the end work time.": "เวลาสิ้นสุดของเวลาพักไม่สามารถช้ากว่าเวลาสิ้นสุดการทำงานได้",
        "The start time of the break time cannot be earlier than the start work time.": "เวลาเริ่มต้นของช่วงพักไม่สามารถเร็วกว่าช่วงเวลาเริ่มงานได้",
        "The end time of the valid check time cannot be earlier than the end work time.": "เวลาสิ้นสุดของช่วงเวลาตรวจสอบที่ถูกต้องต้องไม่เร็วกว่าช่วงเวลาสิ้นสุดการทำงาน",
        "The start time of the valid check time cannot be later than the start work time.": "เวลาเริ่มต้นของช่วงเวลาตรวจสอบที่ถูกต้องต้องไม่ช้ากว่าเวลาเริ่มงาน",
        "Deleting failed. The timetable is used by a shift.": "ลบไม่สำเร็จ\nตารางเวลานี้ถูกใช้งานโดยกะงาน",
        "Deleting failed. The shift is in use.": "ลบไม่สำเร็จ\nกะงานกำลังถูกใช้งาน",
        "Deleting failed. The leave type is in use.": "ลบไม่สำเร็จ ประเภทการลายังถูกใช้งานอยู่",
        "Valid time conflicts with an existing schedule.": "เวลาที่กำหนดขัดแย้งกับตารางเวลาที่มีอยู่",
        "The timing for multiple schedules must not coincide.": "เวลาสำหรับตารางเวลาหลายรายการต้องไม่ตรงกัน",
        "Attendance Log": "บันทึกการเข้าร่วมงาน",
        "IQ Offline.": "IQ ออฟไลน์.",
        "The amount of exported data is too large. Please export it in batches.": "ปริมาณข้อมูลที่ส่งออกมีขนาดใหญ่เกินไป กรุณาส่งออกเป็นชุด ๆ",
        "No log to be exported.": "ไม่มีบันทึกที่จะส่งออก",
        "Time format is invalid.": "รูปแบบเวลาไม่ถูกต้อง",
        "No permission to export logs of this type.": "ไม่มีสิทธิ์ในการส่งออกบันทึกประเภทนี้",
        "Project type is invalid.": "ประเภทโครงการไม่ถูกต้อง",
        "Salto Account Blocked.": "บัญชี Salto ถูกบล็อก.",
        "Remote open not in access group.": "ไม่สามารถเปิดประตูจากระยะไกลได้เนื่องจากไม่อยู่ในกลุ่มสิทธิ์",
        "SIP Account required.": "จำเป็นต้องมีบัญชี SIP.",
        "Invalid Username or Password": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
        "Account already linked to another user.": "บัญชีนี้ได้เชื่อมโยงกับผู้ใช้อื่นแล้ว",
        "The account has been added by another user.": "บัญชีนี้ถูกเพิ่มโดยผู้ใช้รายอื่น",
        "Failed to add. This user already has 5 license plates.": "เพิ่มไม่สำเร็จ ผู้ใช้นี้มีป้ายทะเบียนรถครบ 5 แผ่นแล้ว",
        "Parking Lot Name": "ชื่อที่จอดรถ",
        "Please ensure that all doors in the project are activated at the same time.": "กรุณาตรวจสอบให้แน่ใจว่าประตูทั้งหมดในโครงการถูกเปิดใช้งานพร้อมกัน",
        "Please set the perimeter door group first.": "กรุณาตั้งค่ากลุ่มประตูรอบขอบเขตก่อน",
        "Please ensure that all doors in the project are renewed at the same time.": "กรุณาให้แน่ใจว่าประตูทั้งหมดในโครงการได้รับการต่ออายุในเวลาเดียวกัน",
        "When lockdown is on, the controlled relay cannot be modified.": "เมื่ออยู่ในสถานะล็อกดาวน์ รีเลย์ที่ถูกควบคุมจะไม่สามารถแก้ไขได้",
        "Volume": "ระดับเสียง",
        "name": "ชื่อ",
        "Mac": "แมค",
        "Mobile Number doesn\'t exist.": "หมายเลขโทรศัพท์มือถือไม่มีอยู่",
        "Too large data! Please first export the data before %s first,thanks.": "ข้อมูลมีขนาดใหญ่เกินไป! กรุณาส่งออกข้อมูลก่อน %s ก่อน ขอบคุณค่ะ",
        "Phone number": "หมายเลขโทรศัพท์",
        "network group": "กลุ่มเครือข่าย",
        "Company name": "ชื่อบริษัท",
        "Group name": "ชื่อกลุ่ม",
        "relay": "รีเลย์",
        "time format": "รูปแบบเวลา",
        "security relay": "รีเลย์ความปลอดภัย",
        "personnel": "บุคลากร",
        "Salto Token Expired.": "Salto โทเค็นหมดอายุแล้ว.",
        "identity information! Please login again": "ข้อมูลระบุตัวตน! กรุณาเข้าสู่ระบบอีกครั้ง",
        "Email is required.": "จำเป็นต้องกรอกอีเมล",
        "Mobile number is required.": "จำเป็นต้องกรอกหมายเลขโทรศัพท์มือถือ",
        "You can\'t make payments for offices in different time zones.": "คุณไม่สามารถชำระเงินสำหรับสำนักงานในเขตเวลาที่แตกต่างกันได้",
        "The current scheduling staff exceeds 200 people.": "ขณะนี้มีพนักงานจัดตารางงานเกิน 200 คน",
        "param": "พารามิเตอร์",
        "Invalid UserName or Password": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "บัญชี Salto KS ของคุณไม่มีสิทธิ์ในการแก้ไขชื่อของล็อก",
        "Owner is required.": "จำเป็นต้องมีเจ้าของ",
        "Office is required.": "จำเป็นต้องมีสำนักงาน.",
        "PIN or RF Card is required.": "จำเป็นต้องใช้ PIN หรือบัตร RF.",
        "RF card": "บัตร RF",
        "Personnel is required.": "ต้องการบุคลากร",
        "email address": "ที่อยู่อีเมล",
        "mobile number": "หมายเลขโทรศัพท์มือถือ",
        "The length must be less than 32 characters.": "ความยาวต้องน้อยกว่า 32 ตัวอักษร.",
        "The length must be less than 256 characters.": "ความยาวต้องน้อยกว่า 256 ตัวอักษร.",
        "Access Group is required.": "จำเป็นต้องมี Access Group.",
        "Device is required.": "จำเป็นต้องมีอุปกรณ์",
        "Admin is required.": "จำเป็นต้องมีผู้ดูแลระบบ",
        "Mobile number": "หมายเลขโทรศัพท์มือถือ",
        "schedules": "ตารางเวลา",
        "Timetable name": "ชื่อกำหนดการ",
        "Shift name": "ชื่อกะ",
        "Leave type": "ประเภทการลา",
        "recheck in time": "เวลาเช็คอินใหม่",
        "recheck out time": "เวลาเช็คเอาท์ใหม่",
        "The building name": "ชื่ออาคาร",
        "Building is required.": "จำเป็นต้องมีอาคาร",
        "selection, The same reader cannot be set for both entry and exit": "การเลือก ผู้อ่านเดียวกันไม่สามารถตั้งค่าสำหรับทั้งทางเข้าและทางออก",
        "Door number": "หมายเลขประตู",
        "door input cannot be selection duplicated.": "ไม่สามารถเลือกอินพุตประตูซ้ำได้",
        "Group is required.": "จำเป็นต้องมี Group.",
        "Title can contain up to 32 characters.": "ชื่อเรื่องสามารถมีได้สูงสุด 32 ตัวอักษร",
        "Content can contain up to 1024 characters.": "เนื้อหาสามารถมีได้สูงสุด 1024 อักขระ",
        "Content can contain up to 64 characters.": "เนื้อหาสามารถมีได้สูงสุด 64 ตัวอักษร",
        "Report is required.": "จำเป็นต้องมีรายงาน",
        "ID is required.": "จำเป็นต้องใช้ ID.",
        "The office does not exist.": "สำนักงานนี้ไม่มีอยู่",
        "Office name": "ชื่อสำนักงาน",
        "The Temp Key does not exist.": "Temp Key ไม่พบอยู่",
        "autolock time": "เวลา autolock",
        "The User does not exist.": "ไม่มีผู้ใช้นี้อยู่",
        "The Installer does not exist.": "The Installer does not exist.",
        "The Project does not exist.": "โปรเจกต์นี้ไม่มีอยู่",
        "The Distributor does not exist.": "ตัวแทนจำหน่ายนี้ไม่มีอยู่",
        "The Community Device does not exist.": "อุปกรณ์ชุมชนไม่มีอยู่",
        "The Property Manager does not exist.": "ไม่พบผู้จัดการอสังหาริมทรัพย์",
        "The Sub Distributor does not exist.": "ตัวแทนจำหน่ายย่อยนี้ไม่มีอยู่",
        "The Single Slave does not exist.": "ไม่มีบัญชี Single Slave นี้อยู่",
        "The Property Manager EndUser does not exist.": "ไม่พบผู้ใช้ปลายทางของผู้จัดการอสังหาริมทรัพย์",
        "The Family Member does not exist.": "The Family Member does not exist. สมาชิกในครอบครัวนี้ไม่มีอยู่",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "คุณได้ขอรหัสเข้าถึงครบ 10 ครั้งภายในระยะเวลา 30 นาทีแล้ว กรุณาลองใหม่อีกครั้งในภายหลัง",
        "This Email doesn\'t exist.": "อีเมลนี้ไม่มีอยู่จริง",
        "detection type": "ประเภทการตรวจจับ",
        "Device UUID": "รหัสประจำอุปกรณ์ UUID",
        "smart lock device": "อุปกรณ์สมาร์ทล็อก",
        "You are trying too often, please try again in 5 minutes.": "คุณพยายามบ่อยเกินไป กรุณาลองใหม่อีกครั้งใน 5 นาที",
        "Monitoring Scope": "ขอบเขตการตรวจสอบ",
        "get card list for lock error": "ดึงรายการบัตรสำหรับข้อผิดพลาดล็อก",
        "get card list parse fail": "get card list parse fail",
        "get pin list for lock error": "รับรายการพินสำหรับข้อผิดพลาดการล็อก",
        "get pin list parse fail": "การดึงรายการพินล้มเหลว",
        "fingerprint code must be less than 2048 characters or empty.": "รหัสลายนิ้วมือต้องมีความยาวน้อยกว่า 2048 ตัวอักษรหรือเว้นว่างไว้",
        "Personnel not in office.": "บุคลากรไม่อยู่ในสำนักงาน",
        "customize form fail.": "ปรับแต่งฟอร์มล้มเหลว",
        "smart lock type error.": "ข้อผิดพลาดประเภทสมาร์ทล็อก.",
        "invalid client id or secret": "client id หรือ secret ไม่ถูกต้อง",
        "invalid account or password": "บัญชีหรือรหัสผ่านไม่ถูกต้อง",
        "invalid access token": "โทเค็นการเข้าถึงไม่ถูกต้อง",
        "invalid refresh token": "โทเค็นรีเฟรชไม่ถูกต้อง",
        "no permission to access this project": "ไม่มีสิทธิ์ในการเข้าถึงโปรเจกต์นี้",
        "Stay Alarm Time": "คงเวลาสัญญาณเตือน",
        "This function only support sl20 lock.": "ฟังก์ชันนี้รองรับเฉพาะล็อก sl20 เท่านั้น.",
        "Json marshal error.": "ข้อผิดพลาดในการแปลงข้อมูล Json",
        "Json unmarshal error.": "ข้อผิดพลาดในการแปลงค่า Json",
        "Illegal request, not added within valid time.": "คำขอไม่ถูกต้อง ไม่ได้เพิ่มภายในเวลาที่กำหนด",
        "invalid nvr type": "ประเภท nvr ไม่ถูกต้อง",
        "project is empty": "โปรเจกต์ว่างเปล่า",
        "project type is invalid": "project type is invalid ประเภทโครงการไม่ถูกต้อง",
        "owner is invalid": "owner is invalid เจ้าของไม่ถูกต้อง",
        "url is invalid": "url ไม่ถูกต้อง",
        "password is invalid": "รหัสผ่านไม่ถูกต้อง",
        "building is invalid": "อาคารไม่ถูกต้อง",
        "fail to get data": "ไม่สามารถดึงข้อมูลได้",
        "invalid allow pm view type": "ประเภทการอนุญาตให้ดู pm ไม่ถูกต้อง",
        "Data not exist.": "ไม่มีข้อมูลดังกล่าว",
        "cannot find community PrivateKey.": "ไม่พบคีย์ส่วนตัวของชุมชน",
        "cannot find single PrivateKey.": "ไม่พบคีย์ส่วนตัวเพียงอันเดียว.",
        "The third party not exist.": "บุคคลที่สามไม่มีอยู่",
        "fingerprint code must be equal 1620 characters or empty.": "รหัสลายนิ้วมือต้องมีความยาวเท่ากับ 1620 ตัวอักษรหรือเว้นว่าง",
        "You are trying too often, please try again in 5 minutes": "คุณพยายามบ่อยเกินไป กรุณาลองใหม่อีกครั้งใน 5 นาที",
        "You cannot link an account that already link other accounts.": "คุณไม่สามารถเชื่อมโยงบัญชีที่ได้เชื่อมโยงกับบัญชีอื่นแล้ว",
        "You cannot link multiple property manager accounts under the same installer account.": "คุณไม่สามารถเชื่อมโยงหลายบัญชีผู้จัดการอสังหาริมทรัพย์ภายใต้บัญชีผู้ติดตั้งเดียวกันได้",
        "You cannot link to the currently logged in account.": "คุณไม่สามารถเชื่อมโยงกับบัญชีที่กำลังเข้าสู่ระบบอยู่ในขณะนี้",
        "You can only import one file at a time. Please wait for the current import to finish.": "คุณสามารถนำเข้าไฟล์ได้ครั้งละหนึ่งไฟล์เท่านั้น กรุณารอให้นำเข้าปัจจุบันเสร็จสิ้นก่อน",
        "File check failed. Please download the latest template and try again.": "การตรวจสอบไฟล์ล้มเหลว กรุณาดาวน์โหลดเทมเพลตล่าสุดและลองใหม่อีกครั้ง",
        "Dynamic QR Code not active.": "รหัส QR แบบไดนามิกยังไม่ได้เปิดใช้งาน",
        "Dynamic QR Code not enable.": "ยังไม่ได้เปิดใช้ฟังก์ชันรหัส QR แบบไดนามิก",
        "{0} not found.": "ไม่พบ {0}",
        "Tier charge plan": "แผนการคิดค่าบริการแบบขั้นบันได",
        "Feature billing charge plan new": "แผนการเรียกเก็บเงินตามฟีเจอร์แบบใหม่",
        "Feature billing gradient charge plan": "แผนการเรียกเก็บเงินตามฟีเจอร์แบบไล่ระดับ",
        "The exit time cannot be earlier than the entry time.": "เวลาออกไม่สามารถก่อนเวลาเข้าได้",
        "Access Denied.": "การเข้าถึงถูกปฏิเสธ",
        "User Name or Password": "ชื่อผู้ใช้หรือรหัสผ่าน",
        "You can only link up to 5 sites.": "คุณสามารถเชื่อมโยงได้สูงสุด 5 โครงการเท่านั้น",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "ป้ายทะเบียนนี้ได้ลงทะเบียนให้กับผู้อยู่อาศัยแล้ว และไม่สามารถเพิ่มไปยังรายการบล็อกได้",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "ป้ายทะเบียนนี้ถูกขึ้นบัญชีดำและไม่สามารถลงทะเบียนเป็นยานพาหนะได้",
        "Elevator not configured in company access floor.": "ไม่ได้กำหนดลิฟต์ในชั้นที่บริษัทกำหนดให้เข้าถึง",
        "the device is not in the office": "อุปกรณ์ไม่ได้อยู่ในสำนักงาน",
        "A maximum of 1000 data items can be imported": "สามารถนำเข้าข้อมูลได้สูงสุด 1000 รายการ",
        "Exit time cannot be later than the current time.": "เวลาออกไม่สามารถช้ากว่าเวลาปัจจุบันได้",
        "You can only import a file at a time in the current parking lot.": "ในลานจอดรถปัจจุบัน คุณสามารถนำเข้าได้ครั้งละไฟล์เดียวเท่านั้น",
        "The license plate is already in the blocklist.": "ป้ายทะเบียนนี้มีอยู่ในรายการบล็อกแล้ว",
        "Building name too long.": "ชื่ออาคารยาวเกินไป",
        "Unlock failed. Permission denied by user.": "ปลดล็อกล้มเหลว ผู้ใช้ปฏิเสธการอนุญาต",
        "Please remove the sensor device(s) before disabling this feature.": "โปรดลบอุปกรณ์เซ็นเซอร์ออกก่อนปิดใช้งานฟีเจอร์นี้",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "การดำเนินการล้มเหลว! ผู้ใช้รายนี้เกินขีดจำกัดรายวัน 15 รายการแล้ว",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "แต่ละโปรเจกต์สามารถเพิ่มอุปกรณ์สาธารณะได้สูงสุด {0} เครื่อง หากต้องการเพิ่มมากกว่านี้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของ Akuvox ที่ support{'@'}akuvox.com",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "แต่ละโปรเจกต์สามารถเพิ่มบัญชีพนักงานได้สูงสุด {0} บัญชี หากต้องการเพิ่มมากกว่านี้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของ Akuvox ที่ support{'@'}akuvox.com",


    }
};
